import { useEffect } from 'react';
import { renderRoutes } from 'react-router-config';
import { useHistory } from 'react-router-dom';

import { useRedirectPath } from 'models/mainSite';

import MainLayout from 'layouts/Main';

import type { RouteConfigComponentProps } from 'react-router-config';

const MainRoot = ({ route }: RouteConfigComponentProps) => {
    const {
        location: { pathname },
        replace,
    } = useHistory();

    const [, { setRedirectPath }] = useRedirectPath();

    useEffect(() => {
        if (pathname !== '/') {
            setRedirectPath(pathname);
            replace('/');
        }
    }, []);

    return (
        <MainLayout>
            {/* child routes won't render without this */}
            {renderRoutes(route && route.routes)}
        </MainLayout>
    );
};

export default MainRoot;
